module.exports = __webpack_public_path__ + "static/img/press.9e4f047.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/press.png
// module id = IKgq
// module chunks = 2